import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Blog.css";
import AnimatedTitle from "../AnimatedText/AnimatedTitle";

const Blog = () => {
    const [active, setActive] = useState(0);
    const navigate = useNavigate();

    const slides = [
        {
            id: 0,
            title: "Neón w/ Domelipa",
            image: "/images/blog/blog-img1.jpg",
            link: "/AE"
        },
        {
            id: 1,
            title: "Primavera con Domelipa",
            image: "/images/blog/blog-img2.jpg",
            link: "/AE2"
        },
        {
            id: 2,
            title: "Degradados perfectos",
            image: "/images/blog/blog-img3.jpg",
            link: "/pandora"
        },
    ];

    const handleSlideClick = (index, link) => {
        if (active === index) {
            navigate(link);
        } else {
            setActive(index);
        }
    };

    return (
        <main className="blog-page">
            <section>
                <div className="animated-tittle-blog">
                    <AnimatedTitle
                        text="we make it happen"
                        specialWord="happen"
                    />
                </div>
            </section>
            
            <section className="blog-hero">
                <div className="blog-hero-content">
                    <span className="blog-tag">
                        <img src="/images/blog/Ikon.png" className="icono-blog-tag" alt="icon" />
                        Blog
                    </span>
                    <h1 className="blog-title">
                        Conoce como creamos <br />
                        <span>experiencias Visuales</span> <br />
                        que venden.
                    </h1>
                    <p className="blog-description">
                        Soluciones diseñadas para comunicar, destacar y generar impacto real en cada espacio.
                    </p>
                </div>
                <div className="blog-hero-image" />
            </section>

            <section className="blog-slider-section">
                <div className="blog-slider-container">
                    <div className="blog-tittle-slider">
                        <img src="/images/logo/MotiPuntos.svg" alt="dots" className="blog-moti-dots" />
                        <span>Así como los grandes, <strong>potencia</strong> tu marca desde lo visual</span>
                    </div>
                    <div className="blog-slider-wrapper">
                        <div className="blog-slider-text">
                            <h2>Conoce. <br /> Crea. <br /> Crece.</h2>
                            <button className="blog-slider-btn">
                                <img src="/images/blog/arrow.svg" className="arrow-blog" alt="arrow" />
                            </button>
                        </div>

                        <div className="blog-slider">
                            {slides.map((slide, index) => (
                                <div
                                    key={slide.id}
                                    className={`blog-slide ${active === index ? "active" : ""}`}
                                    style={{ backgroundImage: `url(${slide.image})` }}
                                    onClick={() => handleSlideClick(index, slide.link)}
                                >
                                    <span className="blog-slide-title">
                                        {slide.title}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="blog-moti-section">
                <div className="blog-moti-title">
                    <img src="/images/logo/Logo Moti.svg" alt="logo" className="blog-moti-ico" />
                    <span className="blog-tittle-moti-span">¿Trabajamos en tu <span className="motiblog-especial">próximo proyecto?</span></span>
                    <span className="blog-subtittle-moti-span"> Llevemos tu marca al punto de venta con soluciones de alto impacto.</span>
                </div>
                
                <div className="blog-moti-header">
                    <h2>¿Por qué elegir Moti?</h2>
                    <img src="/images/logo/MotiPuntos.svg" alt="dots" className="blog-moti-dots" />
                </div>

                <div className="blog-moti-cards">
                    <div className="blog-moti-card blog-moti-card-green">
                        <img src="/images/blog/Motipuntos-3.svg" alt="dots" className="blog-moti-dots" />
                        <h3>Experiencia<br />en proyectos reales<br />de alto impacto</h3>
                        <img src="/images/blog/stars.png" alt="stars" className="blog-moti-card-icon" />
                    </div>

                    <div className="blog-moti-card blog-moti-card-orange">
                        <img src="/images/blog/Motipuntos.svg" alt="dots" className="blog-moti-dots" />
                        <h3>Soluciones integrales, de la idea<br />a la instalación</h3>
                        <span>Acompañamos cada proyecto desde el concepto, diseño y producción hasta la entrega final.</span>
                    </div>

                    <div className="blog-moti-card blog-moti-card-pink">
                        <img src="/images/blog/Motipuntos-1.svg" alt="dots" className="blog-moti-dots" />
                        <h3>Calidad, materiales<br />y tecnología profesional</h3>
                        <span>Trabajamos con materiales y procesos de impresión de alto nivel.</span>
                    </div>

                    <div className="blog-moti-card blog-moti-card-beige">
                        <img src="/images/blog/Motipuntos-2.svg" alt="dots" className="blog-moti-dots" />
                        <h3>Enfoque estratégico en visual merchandising</h3>
                        <img src="/images/blog/beige.svg" alt="idea" className="blog-moti-card-icon-beige" />
                    </div>
                </div>

                <div className="bottom-text-blog">
                    <img src="/images/logo/Logo Moti.svg" alt="logo" className="blog-moti-ico" />
                    <span>ready to print</span>
                </div>
            </section>
        </main>
    );
};

export default Blog;